// extracted by css-extract-rspack-plugin
export default {"card":"card-xztyO0","title":"title-GtJgoX","description":"description-ukVWRn","iconBadge":"iconBadge-uqgTwX"};